import http from './http';

export default {
    isHaveData(params){
        return http.get('business-demo/cainiao/getCountRecord', { params });
    },
    getCabinets(params) {
        return http.get('business-demo/cainiao/getAuthList', { params });
    },
    getTakeOutCabinets(params){
        return http.get('business-demo/cainiao/getAuthRecordList', { params });
    },
    getDetail(params){
        return http.get('business-demo/cainiao/getAuthInfo', { params });
    },
    getTakeOutDetail(params){
        return http.get('business-demo/cainiao/getRecordInfo', { params });
    },

    //消息中心
    getNotice(params){
        return http.get('common-user/common/message/getMsgNormalList', { params });
    }
}
